/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { sectionCss } from '../style'
import React from 'react'
import { Disclosures, show, format, arrayFrom, Loading } from '../../twd'
import CATEGORIES from './categories'
import useGreenBonds from './use-green-bonds'

export default () => {

    let { status, error, categories } = useGreenBonds()

    return <React.Fragment>
    <div id="green-bond-search" className="vertical-offset-sm"></div>
    <div data-name='municipals-green-bond-search' className="container vertical-offset-sm" css={sectionCss}>
        <div className="row vertical-offset-sm"></div>

        <div className="row"><div className="col-xs-12">
            <h3 className="medium-header">Green Bond Search</h3>
            <p>Quick access to municipal market offerings focused on environmental, social and governance (ESG) initiatives. </p>
            <p>Click a “View Results” link to see offerings associated with your chosen category.</p>
            <hr aria-hidden="true" />
        </div></div>

        <Loading status={status} error={error}>
        {
            arrayFrom(categories).map( (c,i) => {
                let a = CATEGORIES[c.greenBondGroup]
                if (!a) return null

                let cat = {
                    ...a,
                    offerCount: c.offerCount
                }

                let sp = {
                    holdInvType:['M'],
                    holdIssueType: ['Envrnmntl', 'Green'],
                    persistToPreviousSearches: false,
                    offeringType: ['ask-side'],
                    ...(cat.searchParams)
                }

                return <React.Fragment key={i}>
                    <div className="row vertical-offset-sm"></div>
                    <div className="row">
                        <div className="col-xs-3 text-center">{cat.icon}</div>
                        <div className="col-xs-9">
                            <label className="label-large text-bold">{cat.label}</label>
                            <br/>
                            <button
                            data-name='municipals-green-bond-search-item'
                            className="btn-link label-large text-bold"
                            onClick={() => {
                                show('offerings', {
                                    searchParams:sp,
                                    _ts: Date.now(),
                                    from:'municipals/green-bond-search'
                                })
                            }}>View ({format.count(cat.offerCount)}) Results</button>
                        </div>
                    </div>
                </React.Fragment>
            })
        }
        </Loading>

        <div className="row vertical-offset-sm">
            <div className="col-md-12 col-xs-12 text-right">
                <Disclosures
                    dataName='municipals-green-bond-search-disclosures-link'
                    html={DISCLOSURES}
                />
            </div>
        </div>

    </div>
    </React.Fragment>
}

const DISCLOSURES = `
<p>The Green Bond Search feature provides quick access to Green Bond
offerings on the platform. Green bonds are fixed income securities
that specifically allocate their proceeds to fund projects with
an environmental and/or climate-related benefit. Each green bond theme below
is grouped by their use of proceeds category and will display
search results according to the following:
</p>

<p><b>Transportation:</b> Mass/Rapid Transportation, Airports</p>
<p><b>Water & Power:</b> Water, Water & Sewer, Sewer, Seaports/Marine Terminals, Flood Control/Storm Drain, Electricity & Public Power, Comb Utilities</p>
<p><b>Housing & Government Buildings:</b> Multi-Family Housing, Single-Family Housing, Government/Public Buildings, Office Building/LTD Partnership, Single-Family Housing</p>
<p><b>Education & Healthcare:</b> Primary/Secondary Education, Public Higher Education, Private Higher Education, Charter School, Hospitals</p>
<p><b>Pollution, Sanitation & Preservation:</b> Sanitation, Solid Wastes & Reservation Recovery, Land Preservation, Pollution Control</p>
`